import React from 'react';
import { css } from '@emotion/react';
import { Flex, Text, Link, theme } from '@xometry/xometry_loft';

const TeamNotFoundPanel = () => {
  return (
    <Flex flexDirection="column" alignItems="center" marginTop="80px">
      <img
        src={`https://assets.xometry.com/Spot-Discussion.svg`}
        css={css`
          width: 284px;
        `}
        alt="Accept Organization Invitation"
      />
      <Flex marginTop={theme.space[6]}>
        <Text kind="page-title">Team Not Found</Text>
      </Flex>
      <Text
        width="631px"
        marginTop={theme.space[6]}
        justifyContent="center"
        fontSize={theme.fontSizes[2]}
      >
        This team has been archived, does not exist, or you do not have access
        to it. If the issue persists, contact{' '}
        <Link fontSize={theme.fontSizes[2]} href="mailto:support@xometry.com">
          {'support@xometry.com'}
        </Link>
        .
      </Text>
    </Flex>
  );
};

export default TeamNotFoundPanel;
